import React, { useContext } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@components/Typography";
import useStyles from "./styles";
import { Context } from "@features/Wallets/context/context";
import { getCurrencyMeta, getIconPath } from "@core/utils/getCurrencyMeta";

export default function SelectCurrency(props) {
  const classes = useStyles();
  const { handleChange, name, placeholder, IRT } = props;
  const { state } = useContext(Context);

  return (
    <Select
      variant="outlined"
      onChange={handleChange}
      defaultValue={!!props.defaultValue ? props.defaultValue : ""}
      className={classes.select}
      name={name}
      displayEmpty
      MenuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        getContentAnchorEl: null,
      }}
    >
      {!!placeholder && (
        <MenuItem value="" className={classes.placeholder}>
          {placeholder}
        </MenuItem>
      )}

      {state.wallet.map(
        (item) =>
          (!IRT ? item.currencyName !== "IRT" : item.currencyName) && (
            <MenuItem key={item.id} value={item.currencyName}>
              <div className={classes.styleMenuItem}>
                <img
                  className={classes.MenuItemImg}
                  src={getIconPath(item.currencyName)}
                  alt={item.currencyName}
                />
                <Typography variant="xs" className={classes.MenuItemText}>
                  {getCurrencyMeta(item.currencyName).name}
                </Typography>{" "}
                <Typography
                  variant="xs"
                  className={classes.MenuItemTextCoin}
                >{`(${item.currencyName})`}</Typography>
              </div>
            </MenuItem>
          )
      )}
    </Select>
  );
}
